module.exports = __webpack_public_path__ + "img/icon_home.9e083b2e.svg";